<template>
  <v-container id="provider">
    <v-row>
      <h1 class="mt-12 mb-12  font-weight-light">
        Provider
      </h1>
    </v-row>
    <v-row>
      <v-col>
        <v-card-text>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="title"
              :rules="textFieldRules"
              :counter="10"
              label="Title"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-file-input
              v-model="image"
              :rules="rules"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Pick an image"
              prepend-icon="mdi-camera"
              label="Image"
            ></v-file-input>
          </v-col>
          <v-col cols="12" md="6">
            <v-file-input
              v-model="videosrc"
              :rules="rules"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Pick a video"
              prepend-icon="mdi-video"
              label="Video"
            ></v-file-input>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="url"
              :rules="textFieldRules"
              :counter="10"
              label="URL"
              required
            ></v-text-field>
          </v-col>
          <div class="my-4 subtitle-1 black--text">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="price"
                :rules="textFieldRules"
                :counter="10"
                label="Price"
                required
              ></v-text-field>
            </v-col>

            <!-- <v-chip class="ml-4">type</v-chip> -->
            <v-col cols="12" md="6">
              <v-select
                v-model="type"
                :items="types"
                chips
                label="Type"
                multiple
                outlined
              ></v-select>
            </v-col>
          </div>

          <v-col cols="12" md="6">
            <v-textarea
              outlined
              name="input-7-4"
              label="Description"
              value="Describe your provided listing with a couple of short sentences here."
            ></v-textarea>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
              v-model="language"
              :items="languages"
              :menu-props="{ maxHeight: '400' }"
              label="Languages"
              multiple
              hint="Pick the languages you support."
              persistent-hint
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="a11y"
              :items="a11ys"
              :menu-props="{ maxHeight: '400' }"
              label="Accessibility"
              multiple
              hint="Pick the a11y features you support."
              persistent-hint
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="phone"
              :rules="textFieldRules"
              :counter="10"
              label="Phone Number"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="address"
              :rules="textFieldRules"
              :counter="10"
              label="Address"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="email"
              :rules="textFieldRules"
              :counter="10"
              label="Email"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="hours"
              :rules="textFieldRules"
              :counter="10"
              label="Hours of Operation"
              required
            ></v-text-field>
          </v-col>
        </v-card-text>

        <v-card-actions class="mb-12">
          <v-row>
            <v-col>
              <v-btn
                class="pl-12 pr-12"
                x-large
                @click="postNewItem()"
                color="primary"
                aria-label="Enroll button"
              >
                <v-icon class="pr-3">mdi-checkbox-marked-circle-outline</v-icon>
                Submit New Listing
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Provider',
  data() {
    return {
      title: '',
      url: '',
      type: [''],
      price: '',
      image: '',
      address: '',
      phone: '',
      language: [''],
      hours: '',
      a11y: '',
      email: '',
      description: '',
      videosrc: '',
      gmap: '',
      zipcode: 2120350,
      types: ['website', 'hardware', 'assistive tech', 'group', 'fitness', 'online', 'vision health', 'hotlines', 'internet', 'personal emergency response system'],
      languages: ['spanish', 'mandarin', 'vietnamese', 'tagalog', 'english', 'arabic', 'armenian', 'bengali', 'german', 'greek'],
      a11ys: ['wheelchair', 'elevator', 'power-assisted doors', 'ramp', 'minimum 32" wide opening', 'hallways free of obstruction', 'signage'],
      textFieldRules: [
        (value) => !!value || 'Required.',
        (value) => (value && value.length >= 3) || 'Min 3 characters',
      ],
    };
  },
  methods: {
    postNewItem() {
      const data = {
        fields: {
          TITLE: `${this.title}`,
          URL: `${this.url}`,
          TYPE: `${this.type.join(' ')}`,
          LANGUAGE: `${this.language.join(' ')}`,
          PRICE: `${this.price}`,
          IMAGE: `${this.image}`,
          ADDRESS: `${this.address}`,
          PHONE: `${this.phone}`,
          HOURS: `${this.hours}`,
          A11Y: `${this.a11y}`,
          EMAIL: `${this.email}`,
          DESCRIPTION: `${this.description}`,
          VIDEOSRC: `${this.videosrc}`,
          GMAP: `${this.gmap}`,
          ZIPCODE: this.zipcode,
          UNDER_REVIEW: 'TRUE',
        },
      };

      const options = {
        headers: {
          Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
          'Content-Type': 'application/json',
        },
      };

      console.log(data);
      console.log(options);

      axios
        .post(
          'https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/item-data',
          data,
          options
        )
        .then(
          (r) => {
            console.log(r);
            this.$store.dispatch('setSnackbar', {
              color: 'success',
              text: 'Your new listing has been submitted.',
            });
            location.reload();
          },
          (error) => {
            console.log(error);
            this.$store.dispatch('setSnackbar', {
              color: 'error',
              text: 'Your new listing was unable to be submitted.',
            });
          }
        );
    },
    getSimilarTo() {
      axios
        .get(
          'https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/item-data?view=Grid%20view',
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
            },
          }
        )
        .then(
          (r) => {
            const similar = r.data.records
              .sort(() => 0.5 - Math.random())
              .slice(0, 6);
            this.similarTo = similar;
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>

<style scoped></style>
